export default {


  Sample:[ // Dashboard Only 
  {
      name: 'hm',
      url: '/dashboard',
      icon: 'fa-home'
    },
  ],

  

}



// WEBPACK FOOTER //
// ./src/_nav.js